import {Grid} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import ButtonWithProgress from "../../../../../../../../../ui/buttons/button-with-progress/ButtonWithProgress";

const ActivationSummaryActions = (props) => {
    return (
        <Grid container justifyContent="space-between">
            <Button variant="outlined"
                    onClick={props.setPreviousStep}
                    color="primary">
                Indietro
            </Button>
            <ButtonWithProgress
                    text="Conferma"
                    loading={props.loading}
                    variant="contained"
                    handleClick={props.onConfermaClick}
                    color="primary"/>
        </Grid>
    )
}

ActivationSummaryActions.propTypes = {
    setPreviousStep: PropTypes.func.isRequired,
    onConfermaClick: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
}

export default ActivationSummaryActions;